import React, { useEffect, useId, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import BorderedSec from "../../UI/BorderedSec";
import Card from "../../UI/Card/Card";
import SecBTN from "../../UI/SecBTN";
import classes from "./Questions.module.css";
import { isEmpty, linkReplaceFn } from "../../utils/custom_funtions";
import Modals from "../../UI/Modals/Modals";
import Input from "../../UI/Input/Input";
import userService from "../../app/services/user.service";
import SuccessModal from "../../UI/SuccessModal/SuccessModal";
import error from "../../assets/img/error-vector.png";
import UsedQTable from "../../Pages/CreatePaper/PaperMatrix/UsedQTable/Table";
import Toast from "../../UI/Toast/Toast";
import { toast } from "react-toastify";
import Graybg from "../../UI/Graybg";
import Select from "../../UI/Select/Select";
import { ThreeDots } from 'react-loader-spinner'

const Questions = (props) => {
  const { data, isBoth, paraIndexCondition } = props;
  console.log('data',data)
  const user_id = JSON.parse(localStorage.getItem("user"))?.data?.user?.user_id;
  //changeQ popup
  const [showPopUp4, setShowPopUp4] = useState(false);
  const [showPopUp5, setShowPopUp5] = useState(false);
  const [showPopUp6, setShowPopUp6] = useState(false);
  const [showPopUp7, setShowPopUp7] = useState(false);
  // const newQidRef = useRef("")
  const [showPopUp8, setShowPopUp8] = useState(false);
  const [showPopUp9, setShowPopUp9] = useState(false);
  const [showPopUp10, setShowPopUp10] = useState(false);
  //Used qustions
  const [showPopUp11, setShowPopUp11] = useState(false);
  const [showPopUp12, setShowPopUp12] = useState(false);
  const [newQid, setNewQid] = useState("");
  const [reasonList, setReasonList] = useState([]);
  const [topicList, setTopicList] = useState([]);
  const [subTopicList, setSubTopicList] = useState([]);
  const [toughnessList, setToughnessList] = useState([]);
  const [reasonId, setReasonId] = useState('');
  const [errMsg, setErrMsg] = useState("");
  const [selectedTopic, setSelectedTopic] = useState('');
  const [selectedSubTopic, setSelectedSubTopic] = useState('');
  const [selectedToughness, setSelectedToughness] = useState('');
  const [loading, setLoading] = useState({loader1:false,loader2:false});
  const [quesAvailability, setQuesAvailability] = useState({"used":"","unused":""});
  const [quesData, setQuesData] = useState(() => {
    return {
      ...data,
      m_p_text: linkReplaceFn(data.m_p_text),
      m_p_text_hindi: linkReplaceFn(data.m_p_text_hindi),
      p_text: linkReplaceFn(data.p_text),
      p_text_hindi: linkReplaceFn(data.p_text_hindi),
      q_text: linkReplaceFn(data.q_text),
      sol_text: linkReplaceFn(data.sol_text),
      q_text_hindi: linkReplaceFn(data.q_text_hindi),
      sol_text_hindi: linkReplaceFn(data.sol_text_hindi),
      h_option: linkReplaceFn(data.h_option),
      eng_option: linkReplaceFn(data.eng_option),
    };
  });
  const [prevUsedQues, setPrevUsedQues] = useState([]);
  const [availableQues, setAvailableQues] = useState([]);
  const [limit, setLimit] = useState(0);

  const qUsedHandler = () => {
    // console.log("qid",quesData.qid)
    userService.getPreviousExamQid(quesData.qid)
    .then((res)=>{
      // console.log(res.data.data);
      const datas = res.data.data[0];
      setPrevUsedQues((prev) => {
        let newArr = [];
      console.log('datas',datas)
      for (const num in datas) {
        newArr.push(datas[num]);
      }
      console.log('newArr',newArr)
      return newArr;
      });
      setShowPopUp11(true)
    })
    .catch(err => {
      console.log(err);
      toast.error("Something went wrong !")
    })
  }
  
  const hideHandler = () => {
    setShowPopUp4(false);
    setShowPopUp5(false);
    setShowPopUp7(false);
    setShowPopUp8(false);
    setShowPopUp9(false);
    setShowPopUp10(false);
    setShowPopUp11(false);
    setShowPopUp12(false);
    setNewQid("");
    setReasonId("")
    setLimit(0)
    setSelectedSubTopic("")
    setSelectedToughness("")
    setQuesAvailability({"used":"","unused":""})
  };
  const onChangeQid = () => {
    const body = {
      paper_id: quesData.paper_id,
      user_id: user_id,
      matrix_id: quesData.matrix_id,
      newQID: newQid,
    };
    userService
      .useNewQid(body)
      .then((res) => {
        // console.log(res.data.data[0]["0"]);
        const data = res.data.data[0]["0"];
        console.log(res)
        setQuesData((prev) => {
          return {
            ...prev,
            ...data,
            m_p_text: linkReplaceFn(data.m_p_text),
            m_p_text_hindi: linkReplaceFn(data.m_p_text_hindi),
            p_text: linkReplaceFn(data.p_text),
            p_text_hindi: linkReplaceFn(data.p_text_hindi),
            q_text: linkReplaceFn(data.q_text),
            sol_text: linkReplaceFn(data.sol_text),
            q_text_hindi: linkReplaceFn(data.q_text_hindi),
            sol_text_hindi: linkReplaceFn(data.sol_text_hindi),
            h_option: linkReplaceFn(data.h_option),
            eng_option: linkReplaceFn(data.eng_option),
          };
        });
        setShowPopUp8(false);
        setShowPopUp9(true);
      })
      .catch((err) => {
        console.log(err);
        setShowPopUp8(false);
        // console.log("err",err.response.data.data)
        setErrMsg(err.response.data.data);
        setShowPopUp10(true);
      });
  };
  const changeQHandler = () => {
    userService.getBlockedReason()
    .then(res => {
      console.log(res.data.data);
      setReasonList(res.data.data);
      setShowPopUp4(true)
    })
    .catch(err => {
      console.log(err);
    })
  }
  const getAvailableQuestions = (lim) => {
    const data = {
      "paper_id":quesData.paper_id,
      "sub_id":quesData.sub_id,
      "faculty_id":quesData.faculty_id,
      "type_id":quesData.type_id,
      "qno":quesData.qno,
      "limit":lim,
    }
    userService
        .getAvailableQues(data)
        .then((res) => {
          const response = res.data.data
          setAvailableQues(() => {
            console.log("Object.entries(response)",Object.entries(response))
            const arrayOfObj = Object.entries(response).map((e) => {
              return {
                ...e[1],
                m_p_text:isEmpty(e[1].m_p_text) ? null : linkReplaceFn(e[1].m_p_text),
                m_p_text_hindi:isEmpty(e[1].m_p_text_hindi) ? null : linkReplaceFn(e[1].m_p_text_hindi),
                p_text: isEmpty(e[1].p_text) ? null : linkReplaceFn(e[1].p_text),
                p_text_hindi:isEmpty(e[1].p_text_hindi) ? null : linkReplaceFn(e[1].p_text_hindi),
                q_text: linkReplaceFn(e[1].q_text),
                sol_text: linkReplaceFn(e[1].sol_text),
                q_text_hindi: linkReplaceFn(e[1].q_text_hindi),
                sol_text_hindi: linkReplaceFn(e[1].sol_text_hindi),
                h_option: linkReplaceFn(e[1].h_option),
                eng_option: linkReplaceFn(e[1].eng_option),
              };
            });
            console.log("getAvailableQues",arrayOfObj);
            return arrayOfObj
          });
          setShowPopUp4(false);
          setShowPopUp5(true);
        })
        .catch((err) => {
          console.log(err);
        });
  }
  const reasonSubmitHandler = () => {
    const body = {
      "qid": quesData.qid,
      "blockid": reasonId,
      "updated_by": user_id
    }
    userService.qidBlockReason(body)
    .then(res => {
      // console.log(res)
      getAvailableQuestions(limit)
    })
    .catch(err => {
      console.log(err);
    })
  }
  const replaceQuestion = (x) => {
    console.log(x);
    console.log("quesData",quesData);
    // console.log('availableQues',availableQues);
    const body = {
      paper_id:quesData.paper_id,
      sub_id:quesData.sub_id,
      faculty_id:quesData.faculty_id,
      type_id:quesData.type_id,
      qno:quesData.qno,
      qid:x.qid,
      pid:x.para_id
    }

    if(paraIndexCondition){
      userService.changeQuestion(body)
    .then(res => {
      const datas = Object.values(res.data.data);
      console.log("changeQuestion1",datas);
      // const data = res.data.data[0]
      // const data1 = res.data.data[1]
      props.replaceQuestionForNext(datas)
      .then(() =>{
        setShowPopUp5(false)
        setShowPopUp7(true)
      })
        // setQuesData((prev) => {
        //   return {
        //     ...prev,
        //     ...data,
        //     m_p_text: linkReplaceFn(data.m_p_text)??null,
        //     m_p_text_hindi: linkReplaceFn(data.m_p_text_hindi)??null,
        //     p_text: linkReplaceFn(data.p_text),
        //     p_text_hindi: linkReplaceFn(data.p_text_hindi),
        //     q_text: linkReplaceFn(data.q_text),
        //     sol_text: linkReplaceFn(data.sol_text),
        //     q_text_hindi: linkReplaceFn(data.q_text_hindi),
        //     sol_text_hindi: linkReplaceFn(data.sol_text_hindi),
        //     h_option: linkReplaceFn(data.h_option),
        //     eng_option: linkReplaceFn(data.eng_option),
        //   };
        // });
        
        // userService
        //   .updateQid({
        //     matrix_id: quesData.matrix_id,
        //     qid: data.qid,
        //     faculty_id: quesData.faculty_id,
        //   })
        //   .then((res) => {
        //     console.log(res);
        //     setShowPopUp5(false)
        //     setShowPopUp7(true)
        //   })
        //   .catch((err) => {
        //     console.log(err);
        //   });
    })
    .catch(err => {
      console.log(err);
    })

    } else {
      userService.changeQuestion(body)
      .then(res => {
        console.log("changeQuestion2",res.data.data[0]);
        const data = res.data.data[0]
          // setQuesData((prev) => {
          //   return {
          //     ...prev,
          //     ...data,
          //     paragraph_id:data.para_id,
          //     m_p_text: linkReplaceFn(data.m_p_text)??null,
          //     m_p_text_hindi: linkReplaceFn(data.m_p_text_hindi)??null,
          //     p_text: linkReplaceFn(data.p_text),
          //     p_text_hindi: linkReplaceFn(data.p_text_hindi),
          //     q_text: linkReplaceFn(data.q_text),
          //     sol_text: linkReplaceFn(data.sol_text),
          //     q_text_hindi: linkReplaceFn(data.q_text_hindi),
          //     sol_text_hindi: linkReplaceFn(data.sol_text_hindi),
          //     h_option: linkReplaceFn(data.h_option),
          //     eng_option: linkReplaceFn(data.eng_option),
          //   };
          // });
          userService
            .updateQid({
              matrix_id: quesData.matrix_id,
              qid: data.qid,
              faculty_id: quesData.faculty_id,
            })
            .then((res) => {
              console.log(res);
              setShowPopUp5(false)
              setShowPopUp7(true)
              props.requestRandomPaperApi()
            })
            .catch((err) => {
              console.log(err);
            });
      })
      .catch(err => {
        console.log(err);
      })
    }
    
  }
  const formId = useId();

  const getTopicBySubid = () => {
    userService
      .getTopicListBySid(quesData.sub_id)
      .then((data) => {
        getToughness()
        setSelectedTopic(quesData.topic_id)
        onTopicChange(quesData.topic_id)
        setTopicList(data.data.data);
        setShowPopUp12(true)
        console.log(quesData)
      })
      .catch((err) => {
        console.log(err);
      });
  }
  const getToughness = () => {
    userService
      .getToughness()
      .then((data) => {
        setToughnessList(data.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }
  const onTopicChange = tid => {
    setSelectedTopic(tid);
    setSelectedSubTopic("");
    userService
      .getSubTopicByTid(tid)
      .then((res) => {
        console.log(res.data.data);
        setSubTopicList(res.data.data);
      })
      .catch((err) => {
        console.error(err);
      });
  }
  const changeQuesionTopicwise = async() => {
    // const body = {
    //   paper_id:quesData.paper_id,
    //   sub_id:quesData.sub_id,
    //   faculty_id:quesData.faculty_id,
    //   type_id:quesData.type_id,
    //   qno:quesData.qno
    // }

    // userService.changeQuestionTopicWise(body)
    // .then(res =>{
    //   console.log('res.data.data',res.data.data);
    // })
    // .catch((err) => {
    //   console.error(err);
    // })
    
if(paraIndexCondition){
  const body = [
    {
      matrix_id: data.matrix_id ? +data.matrix_id : 0,
      paper_id: +data.paper_id,
      qno: data.qno,
      sub_id: +data.sub_id,
      // sec_id: +data.section_id,
      topic_id: selectedTopic,
      sub_topic_id: selectedSubTopic ? +selectedSubTopic : 1,
      type_id: +data.type_id,
      toughness_id: +selectedToughness,
      display_number: +data.qno,
      user_id: +data.faculty_id,
      is_dummy_panel: 0,
    },
    {
      matrix_id: props.nextMatrixId ? +props.nextMatrixId : 0,
      paper_id: +data.paper_id,
      qno: data.qno+1,
      sub_id: +data.sub_id,
      // sec_id: +data.section_id,
      topic_id: selectedTopic,
      sub_topic_id: selectedSubTopic ? +selectedSubTopic : 1,
      type_id: +data.type_id,
      toughness_id: +selectedToughness,
      display_number: +data.qno+1,
      user_id: +data.faculty_id,
      is_dummy_panel: 0,
    },

  ];
  await userService
  .createPaperMatrix(body)
  .then((res) => {
    console.log(res);
    const newBody = {
      paper_id: quesData.paper_id,
      sub_id: quesData.sub_id,
      faculty_id: quesData.faculty_id,
      type_id: quesData.type_id,
      qno: quesData.qno,
    };
    const newBody1 = {
      paper_id: quesData.paper_id,
      sub_id: quesData.sub_id,
      faculty_id: quesData.faculty_id,
      type_id: quesData.type_id,
      qno: quesData.qno+1,
    };

    try {
      userService
      .changeQuestionTopicWise(newBody)
      .then((res) => {
        console.log("res.data.data", res.data.data[0]);
        userService
          .updateQid({
            matrix_id: quesData.matrix_id,
            qid: res.data.data[0].qid,
            faculty_id: quesData.faculty_id,
          })
          .then((res) => {
            console.log(res);
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.error(err);
      });
      userService
      .changeQuestionTopicWise(newBody1)
      .then((res) => {
        console.log("res.data.data", res.data.data[0]);
        userService
          .updateQid({
            matrix_id: props.nextMatrixId,
            qid: res.data.data[1].qid,
            faculty_id: quesData.faculty_id,
          })
          .then((res) => {
            console.log(res);
           
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.error(err);
      });
    } catch (error) {
      
    } finally {
      props.requestRandomPaperApi()
    }

    
  })
  .catch((err) => {
    console.log(err);
  });


} else {
  const body = [
    {
      matrix_id: data.matrix_id ? +data.matrix_id : 0,
      paper_id: +data.paper_id,
      qno: data.qno,
      sub_id: +data.sub_id,
      // sec_id: +data.section_id,
      topic_id: selectedTopic,
      sub_topic_id: selectedSubTopic ? +selectedSubTopic : 1,
      type_id: +data.type_id,
      toughness_id: +selectedToughness,
      display_number: +data.qno,
      user_id: +data.faculty_id,
      is_dummy_panel: 0,
    },
  ];
  await userService
    .createPaperMatrix(body)
    .then((res) => {
      console.log(res);
      const newBody = {
        paper_id: quesData.paper_id,
        sub_id: quesData.sub_id,
        faculty_id: quesData.faculty_id,
        type_id: quesData.type_id,
        qno: quesData.qno,
      };

      userService
        .changeQuestionTopicWise(newBody)
        .then((res) => {
          console.log("res.data.data", res.data.data[0]);
          userService
            .updateQid({
              matrix_id: quesData.matrix_id,
              qid: res.data.data[0].qid,
              faculty_id: quesData.faculty_id,
            })
            .then((res) => {
              console.log(res);
              props.requestRandomPaperApi()
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          console.error(err);
        });
    })
    .catch((err) => {
      console.log(err);
    });
}
   




  }

  useEffect(() => {
    if(quesData.type_id !== (5 || 9 || 10 || 11 || 12 || 13 ||14 || 15)) {
      if(!isEmpty(selectedTopic)&& !isEmpty(selectedSubTopic) && !isEmpty(selectedToughness)){
        const body = {
          "pid": quesData.paper_id,
          "topic_id":selectedTopic,
          "sub_topic_id":selectedSubTopic,
          "toughness_id":selectedToughness,
          "type_id":quesData.type_id
        }
        setLoading({loader1:true,loader2:true})
        userService.getUsedQues(body)
        .then(res => {
          setLoading(prev => {
            return {
              ...prev,
              loader1:false
            }
          })
          setQuesAvailability(prev => {
            return {
              ...prev,
              "used":res.data.data[0].used
            }
          })
        })
        .catch(err =>{
          console.log(err);
          setLoading(prev => {
            return {
              ...prev,
              loader1:false
            }
          })
        })
        userService.getUnusedQues(body)
        .then(res => {
          setLoading(prev => {
            return {
              ...prev,
              loader2:false
            }
          })
          setQuesAvailability(prev => {
            return {
              ...prev,
              "unused":res.data.data[0].not_used
            }
          })
        })
        .catch(err =>{
          console.log(err);
          setLoading(prev => {
            return {
              ...prev,
              loader2:false
            }
          })
        })
      }
    } else {
      if(!isEmpty(selectedTopic) && !isEmpty(selectedToughness)){
        const body = {
          "pid": quesData.paper_id,
          "topic_id":selectedTopic,
          // "sub_topic_id":selectedSubTopic,
          "toughness_id":selectedToughness,
          "type_id":quesData.type_id
        }
        setLoading({loader1:true,loader2:true})
        userService.getUsedQues(body)
        .then(res => {
          console.log("used",res.data.data[0].used);
          setLoading(prev => {
            return {
              ...prev,
              loader1:false
            }
          })
          setQuesAvailability(prev => {
            return {
              ...prev,
              "used":res.data.data[0].used
            }
          })
        })
        .catch(err =>{
          console.log(err);
          setLoading(prev => {
            return {
              ...prev,
              loader1:false
            }
          })
        })
        userService.getUnusedQues(body)
        .then(res => {
          console.log("unused",res.data.data[0].not_used);
          setLoading(prev => {
            return {
              ...prev,
              loader2:false
            }
          })
          setQuesAvailability(prev => {
            return {
              ...prev,
              "unused":res.data.data[0].not_used
            }
          })
        })
        .catch(err =>{
          console.log(err);
          setLoading(prev => {
            return {
              ...prev,
              loader2:false
            }
          })
        })
      }
    } 
    
  },[selectedTopic,selectedSubTopic,selectedToughness])

  return (
    <>
      <Toast />
      {/* Use question success modal */}
      <SuccessModal
        show={showPopUp7}
        onHide={hideHandler}
        title="Question Used Successfully!"
        btnTxt="Ok"
      />
      {/*Change question models*/}
      <Modals show={showPopUp4} onHide={hideHandler}>
        <h5 className="mb-3">Select the reason</h5>
        {reasonList.map((item, i) => {
          return (
            <div key={item.block_id} className={classes.reason}>
              <Form.Check
                id={i + formId + item.block_id}
                type="radio"
                name="blockedReason"
                value={item.block_id}
                label={item.block_name}
                onChange={(e) => setReasonId(e.target.value)}
              />
            </div>
          );
        })}
        <div className="text-center mt-4 mb-2">
          <SecBTN
            disabled={isEmpty(reasonId)}
            className="sec-btn1"
            onClick={reasonSubmitHandler}
          >
            Confirm
          </SecBTN>
        </div>
      </Modals>
      <Modals show={showPopUp5} onHide={hideHandler} size="xl">
        <h5 className="mb-3">Select the question</h5>
        <Graybg>
          {isEmpty(availableQues)
            ? "Not available"
            : availableQues.map((ques) => {
                return (
                  <BorderedSec>
                    <Row>
                      <Col lg={6} md={12} sm={12}>
                        <Card className={classes["sec-card1"]}>
                          {isEmpty(ques.p_text) ? (
                            ""
                          ) : (
                            <div className="mb-2">
                              <b>Paragraph : </b>
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: ques.p_text,
                                }}
                              ></span>
                            </div>
                          )}
                          {isEmpty(ques.m_p_text) ? (
                            ""
                          ) : (
                            <div className="mb-2">
                              <b>Paragraph : </b>
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: ques.m_p_text,
                                }}
                              ></span>
                            </div>
                          )}
                          <b>Question : </b>
                          {isEmpty(ques.q_text) ? (
                            "Not Available"
                          ) : (
                            <span
                              dangerouslySetInnerHTML={{
                                __html: ques.q_text,
                              }}
                            ></span>
                          )}

                          <ol
                            style={{
                              listStyleType: "upper-alpha",
                              marginLeft: "30px",
                            }}
                          >
                            {!isEmpty(ques.eng_option) &&
                              [...new Set(ques.eng_option.split("@@@"))].map(
                                (data, i) => {
                                  return (
                                    <li key={i}>
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html: data,
                                        }}
                                      />
                                    </li>
                                  );
                                }
                              )}
                          </ol>
                        </Card>
                      </Col>
                      <Col lg={6} md={12} sm={12}>
                        <Card className={classes["sec-card1"]}>
                          {isEmpty(ques.p_text_hindi) ? (
                            ""
                          ) : (
                            <div className="mb-2">
                              <b>Paragraph : </b>
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: ques.p_text_hindi,
                                }}
                              ></span>
                            </div>
                          )}
                          {isEmpty(ques.m_p_text_hindi) ? (
                            ""
                          ) : (
                            <div className="mb-2">
                              <b>Paragraph : </b>
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: ques.m_p_text_hindi,
                                }}
                              ></span>
                            </div>
                          )}
                          <b>Question : </b>
                          {isEmpty(ques.q_text_hindi) ? (
                            "Not Available"
                          ) : (
                            <span
                              dangerouslySetInnerHTML={{
                                __html: ques.q_text_hindi,
                              }}
                            ></span>
                          )}

                          <ol
                            style={{
                              listStyleType: "upper-alpha",
                              marginLeft: "30px",
                            }}
                          >
                            {!isEmpty(ques.h_option) &&
                              [...new Set(ques.h_option.split("@@@"))].map(
                                (data, i) => {
                                  return (
                                    <li key={i}>
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html: data,
                                        }}
                                      />
                                    </li>
                                  );
                                }
                              )}
                          </ol>
                        </Card>
                      </Col>

                      <Col lg={6} md={12} sm={12} className="mt-3 mb-2">
                        <p className={classes["crct-ans-opt"]}>
                          Answer : <span>{ques.answer}</span>
                        </p>
                      </Col>
                      <Col lg={12} md={12} sm={12}></Col>

                      <Col lg={6} md={12} sm={12}>
                        <Card className={classes["sec-card1"]}>
                          <b>
                            Solution :{" "}
                            {isEmpty(ques.sol_text) ? (
                              "Not Available"
                            ) : (
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: ques.sol_text,
                                }}
                              ></span>
                            )}
                          </b>
                        </Card>
                      </Col>
                      {isBoth == 1 && (
                        <Col lg={6} md={12} sm={12}>
                          <Card className={classes["sec-card1"]}>
                            <b>
                              Answer :{" "}
                              {isEmpty(ques.sol_text_hindi) ? (
                                "Not Available"
                              ) : (
                                <span
                                  dangerouslySetInnerHTML={{
                                    __html: ques.sol_text_hindi,
                                  }}
                                ></span>
                              )}
                            </b>
                          </Card>
                        </Col>
                      )}
                    </Row>
                    <div className="text-end">
                      <SecBTN
                        className="sec-btn1"
                        onClick={() => replaceQuestion(ques)}
                      >
                        Use
                      </SecBTN>
                    </div>
                  </BorderedSec>
                );
              })}
        </Graybg>
        <div className="d-flex justify-content-between mt-3">
          <SecBTN
            disabled={limit === 0}
            className="sec-btn1"
            onClick={() => {
              setLimit(limit - 1);
              getAvailableQuestions(limit - 1);
            }}
          >
            Prev
          </SecBTN>
          <SecBTN
            className="sec-btn1"
            onClick={() => {
              setLimit(limit + 1);
              console.log("limit", limit);
              getAvailableQuestions(limit + 1);
            }}
          >
            Next
          </SecBTN>
        </div>
      </Modals>
      {/* Use qid model */}
      <Modals show={showPopUp8} onHide={hideHandler}>
        <h5 className="">Use QID</h5>
        <p>Use the QID directly and get the question.</p>
        <Input
          value={newQid}
          type="number"
          placeholder="Enter QID"
          className="my-3"
          onChange={(e) => setNewQid(e.target.value)}
        />
        <div className={classes["sec-qid"]}>
          <SecBTN className="sec-btn" onClick={hideHandler}>
            Cancel
          </SecBTN>
          <SecBTN
            className="sec-btn1"
            disabled={isEmpty(newQid)}
            onClick={onChangeQid}
          >
            Save
          </SecBTN>
        </div>
      </Modals>
      <SuccessModal
        show={showPopUp9}
        onHide={hideHandler}
        title="QID used successfully!"
        btnTxt="Ok"
      />
      <Modals show={showPopUp10} onHide={hideHandler} className="text-center">
        <img src={error} alt="error" />
        <p className="text-center mt-3" style={{ fontWeight: 600 }}>
          {errMsg}
        </p>
      </Modals>
      {/* Used Question */}
      <Modals
        size="lg"
        show={showPopUp11}
        onHide={hideHandler}
        className="text-center"
      >
        <UsedQTable data={prevUsedQues} />
      </Modals>
      <Modals show={showPopUp12} onHide={hideHandler}>
        <div className="mb-3">
          <h5 className="">Change Question Selection</h5>
          <p>Change the selection to get a relevent question</p>
        </div>
        <Form.Group className="mb-2">
          <Form.Label>Select Topic:</Form.Label>
          <Select
            name="topic"
            value={selectedTopic}
            onChange={(e) => onTopicChange(e.target.value)}
          >
            <option value="" disabled>
              Select Topic
            </option>
            {topicList
              .filter((x) => x.status == 1)
              .map((item) => {
                return (
                  <option key={JSON.stringify(item)} value={item.topic_id}>
                    {item.topic_name}
                  </option>
                );
              })}
          </Select>
        </Form.Group>
        {quesData.type_id !== (5 || 9 || 10 || 11 || 12 || 13 || 14 || 15) && (
          <Form.Group className="mb-2">
            <Form.Label>Select Subtopic:</Form.Label>
            <Select
              name="subTopic"
              value={selectedSubTopic}
              onChange={(e) => setSelectedSubTopic(e.target.value)}
            >
              <option value="" disabled>
                Select Subtopic
              </option>
              {subTopicList
                .filter((x) => x.status == 1)
                .map((item) => {
                  return (
                    <option value={item.sub_topic_id}>
                      {item.Sub_topic_name}
                    </option>
                  );
                })}
            </Select>
          </Form.Group>
        )}

        <Form.Group className="mb-3">
          <Form.Label>Select Toughness:</Form.Label>
          <Select
            name="topic"
            value={selectedToughness}
            onChange={(e) => setSelectedToughness(e.target.value)}
          >
            <option value="" disabled>
              Select Toughness
            </option>
            {toughnessList.map((item) => {
              return (
                <option value={item.toughness_id}>{item.toughness}</option>
              );
            })}
          </Select>
        </Form.Group>
        <div className="text-center mb-3">
          <small>
            (Used Questions :{" "}
            <b>
              {isEmpty(quesAvailability.used) ? (
                !loading.loader1 ? (
                  "NA"
                ) : (
                  <ThreeDots
                    height="25"
                    width="25"
                    radius="9"
                    color="#950202"
                    ariaLabel="three-dots-loading"
                    wrapperStyle={{ display: "inline-block" }}
                    wrapperClassName=""
                    visible={true}
                  />
                )
              ) : (
                quesAvailability.used
              )}
            </b>
            {"   "}
            Available Questions :{" "}
            <b>
              {isEmpty(quesAvailability.unused) ? (
                !loading.loader2 ? (
                  "NA"
                ) : (
                  <ThreeDots
                    height="25"
                    width="25"
                    radius="9"
                    color="#950202"
                    ariaLabel="three-dots-loading"
                    wrapperClassName=""
                    visible={true}
                    wrapperStyle={{ display: "inline-block" }}
                  />
                )
              ) : (
                quesAvailability.unused
              )}
            </b>
            )
          </small>
        </div>
        <div className="text-center">
          <SecBTN
            className="sec-btn1"
            disabled={quesData.type_id !== (5 || 9 || 10 || 11 || 12 || 13 || 14 || 15) ? (
              isEmpty(selectedSubTopic) ||
              isEmpty(selectedToughness) ||
              isEmpty(selectedTopic)) :
              isEmpty(selectedToughness) ||
              isEmpty(selectedTopic)
            }
            onClick={changeQuesionTopicwise}
          >
            Save
          </SecBTN>
        </div>
      </Modals>
      <BorderedSec className={quesData.qid === null && classes.error}>
        {isBoth == 1 ? (
          <>
            <Card>
              <Row>
                <Col lg={6} md={8} sm={7}>
                  <p className={classes["completed-ques__text1"]}>
                    Q{quesData.qno}. {quesData.type}
                  </p>
                </Col>
                <Col lg={6} md={4} sm={5}>
                  <div className={classes["sec-editable"]}>
                    <SecBTN
                      type="button"
                      className={classes["cmplte-btn"]}
                      onClick={() => setShowPopUp8(true)}
                    >
                      Use QID
                    </SecBTN>

                    {quesData.type_id == (5 || 9 || 10) ? (
                      paraIndexCondition ? (
                        <SecBTN
                          type="button"
                          className={classes["cmplte-btn"]}
                          onClick={changeQHandler}
                        >
                          Change Ques 
                        </SecBTN>
                      ) : (
                        ""
                      )
                    ) : (
                      <SecBTN
                        type="button"
                        className={classes["cmplte-btn"]}
                        onClick={changeQHandler}
                      >
                        Change Ques 
                      </SecBTN>
                    )}
                    <SecBTN
                      type="button"
                      className={classes["cmplte-btn"]}
                      onClick={getTopicBySubid}
                    >
                      Change Subtopic
                    </SecBTN>
                    <SecBTN
                      className={classes["used-btn"]}
                      onClick={qUsedHandler}
                    >
                      {quesData.total_qid} Times Used
                    </SecBTN>
                  </div>
                </Col>
                <Col lg={3} md={6} sm={12} className="mb-2">
                  <Card className={classes["sec-card"]}>
                    <b>Qid :</b>{" "}
                    {isEmpty(quesData.qid) ? (
                      <span className={classes.errorText}>Not Available</span>
                    ) : (
                      quesData.qid
                    )}
                  </Card>
                </Col>
                <Col lg={3} md={6} sm={12} className="mb-2">
                  <Card className={classes["sec-card"]}>
                    <b>topic :</b> {quesData.topic_name}
                  </Card>
                </Col>
                <Col lg={3} md={6} sm={12} className="mb-2">
                  <Card className={classes["sec-card"]}>
                    <b>Sub-topic :</b> {quesData.sub_topic_name}
                  </Card>
                </Col>
                <Col lg={3} md={6} sm={12} className="mb-2">
                  <Card className={classes["sec-card"]}>
                    <b>Toughness :</b> {quesData.toughness}
                  </Card>
                </Col>
              </Row>
            </Card>
            <Row>
              <Col lg={6} md={12} sm={12}>
                <Card className={classes["sec-card1"]}>
                  {isEmpty(quesData.p_text) ? (
                    ""
                  ) : (
                    <div className="mb-2">
                      <b>Paragraph : </b>
                      <span
                        dangerouslySetInnerHTML={{ __html: quesData.p_text }}
                      ></span>
                    </div>
                  )}
                  {isEmpty(quesData.m_p_text) ? (
                    ""
                  ) : (
                    <div className="mb-2">
                      <b>Paragraph : </b>
                      <span
                        dangerouslySetInnerHTML={{
                          __html: quesData.m_p_text,
                        }}
                      ></span>
                    </div>
                  )}
                  <b>Question : </b>
                  {isEmpty(quesData.q_text) ? (
                    "Not Available"
                  ) : (
                    <span
                      dangerouslySetInnerHTML={{ __html: quesData.q_text }}
                    ></span>
                  )}

                  <ol
                    style={{
                      listStyleType: "upper-alpha",
                      marginLeft: "30px",
                    }}
                  >
                    {!isEmpty(quesData.eng_option) &&
                      [...new Set(quesData.eng_option.split("@@@"))].map(
                        (data, i) => {
                          return (
                            <li key={i}>
                              <div dangerouslySetInnerHTML={{ __html: data }} />
                            </li>
                          );
                        }
                      )}
                  </ol>
                </Card>
              </Col>
              <Col lg={6} md={12} sm={12}>
                <Card className={classes["sec-card1"]}>
                  {isEmpty(quesData.p_text_hindi) ? (
                    ""
                  ) : (
                    <div className="mb-2">
                      <b>Paragraph : </b>
                      <span
                        dangerouslySetInnerHTML={{
                          __html: quesData.p_text_hindi,
                        }}
                      ></span>
                    </div>
                  )}
                  {isEmpty(quesData.m_p_text_hindi) ? (
                    ""
                  ) : (
                    <div className="mb-2">
                      <b>Paragraph : </b>
                      <span
                        dangerouslySetInnerHTML={{
                          __html: quesData.m_p_text_hindi,
                        }}
                      ></span>
                    </div>
                  )}
                  <b>Question : </b>
                  {isEmpty(quesData.q_text_hindi) ? (
                    "Not Available"
                  ) : (
                    <span
                      dangerouslySetInnerHTML={{
                        __html: quesData.q_text_hindi,
                      }}
                    ></span>
                  )}
                  <ol
                    style={{
                      listStyleType: "upper-alpha",
                      marginLeft: "30px",
                    }}
                  >
                    {quesData.h_option !== null &&
                      [...new Set(quesData.h_option.split("@@@"))].map(
                        (data, i) => {
                          return (
                            <li key={i}>
                              <div dangerouslySetInnerHTML={{ __html: data }} />
                            </li>
                          );
                        }
                      )}
                  </ol>
                </Card>
              </Col>

              <Col lg={6} md={12} sm={12} className="mt-3 mb-2">
                <p className={classes["crct-ans-opt"]}>
                  Answer : <span>{quesData.answer}</span>
                </p>
              </Col>
              <Col lg={6} md={12} sm={12}></Col>

              <Col lg={6} md={12} sm={12}>
                <Card className={classes["sec-card1"]}>
                  <b>
                    Solution :{" "}
                    {isEmpty(quesData.sol_text) ? (
                      "Not Available"
                    ) : (
                      <span
                        dangerouslySetInnerHTML={{ __html: quesData.sol_text }}
                      ></span>
                    )}
                  </b>
                </Card>
              </Col>
              <Col lg={6} md={12} sm={12}>
                <Card className={classes["sec-card1"]}>
                  <b>
                    Solution :{" "}
                    {isEmpty(quesData.sol_text_hindi) ? (
                      "Not Available"
                    ) : (
                      <span
                        dangerouslySetInnerHTML={{
                          __html: quesData.sol_text_hindi,
                        }}
                      ></span>
                    )}
                  </b>
                </Card>
              </Col>
            </Row>
          </>
        ) : (
          <Card>
            <Row>
              <Col lg={6} md={8} sm={7}>
                <p className={classes["completed-ques__text1"]}>
                  Q{quesData.qno}. {quesData.type}
                  {/* <span>
                  (Used Questions : <b>22</b> &nbsp; &nbsp; Available Questions
                  : <b>20</b>)
                </span> */}
                </p>
              </Col>
              <Col lg={6} md={4} sm={5}>
                <div className={classes["sec-editable"]}>
                  <SecBTN
                    type="button"
                    className={classes["cmplte-btn"]}
                    onClick={
                      //qidHandler
                      () => setShowPopUp8(true)
                    }
                  >
                    Use QID
                  </SecBTN>
                  {quesData.type_id == (5 || 9 || 10) ? (
                      paraIndexCondition ? (
                        <SecBTN
                          type="button"
                          className={classes["cmplte-btn"]}
                          onClick={changeQHandler}
                        >
                          Change Ques 
                        </SecBTN>
                      ) : (
                        ""
                      )
                    ) : (
                      <SecBTN
                        type="button"
                        className={classes["cmplte-btn"]}
                        onClick={changeQHandler}
                      >
                        Change Ques 
                      </SecBTN>
                    )}
                  <SecBTN
                    type="button"
                    className={classes["cmplte-btn"]}
                    onClick={getTopicBySubid}
                  >
                    Change Subtopic
                  </SecBTN>
                  <SecBTN
                    className={classes["used-btn"]}
                    onClick={qUsedHandler}
                  >
                    {quesData.total_qid} Times Used
                  </SecBTN>
                </div>
              </Col>
              <Col lg={3} md={6} sm={12} className="mb-2">
                <Card className={classes["sec-card"]}>
                  <b>Qid :</b> {quesData.qid}
                </Card>
              </Col>
              <Col lg={3} md={6} sm={12} className="mb-2">
                <Card className={classes["sec-card"]}>
                  <b>topic :</b> {quesData.topic_name}
                </Card>
              </Col>
              <Col lg={3} md={6} sm={12} className="mb-2">
                <Card className={classes["sec-card"]}>
                  <b>Sub-topic :</b> {quesData.sub_topic_name}
                </Card>
              </Col>
              <Col lg={3} md={6} sm={12} className="mb-2">
                <Card className={classes["sec-card"]}>
                  <b>Toughness :</b> {quesData.toughness}
                </Card>
              </Col>
            </Row>
            {/*  */}
            <Card className={classes["sec-card1"]}>
              {isEmpty(quesData.p_text) ? (
                ""
              ) : (
                <div className="mb-2">
                  <b>Paragraph : </b>
                  <span
                    dangerouslySetInnerHTML={{ __html: quesData.p_text }}
                  ></span>
                </div>
              )}
              {isEmpty(quesData.m_p_text) ? (
                ""
              ) : (
                <div className="mb-2">
                  <b>Paragraph : </b>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: quesData.m_p_text,
                    }}
                  ></span>
                </div>
              )}
              <b>Question : </b>
              <span
                dangerouslySetInnerHTML={{ __html: quesData.q_text }}
              ></span>{" "}
              <ol
                style={{
                  listStyleType: "upper-alpha",
                  marginLeft: "30px",
                }}
              >
                {!isEmpty(quesData.eng_option) &&
                  [...new Set(quesData.eng_option.split("@@@"))].map(
                    (data, i) => {
                      return (
                        <li key={i}>
                          <div dangerouslySetInnerHTML={{ __html: data }} />
                        </li>
                      );
                    }
                  )}
              </ol>
            </Card>

            <p className={classes["crct-ans-opt"]}>
              Answer : <span>{quesData.answer}</span>
            </p>
            <Card className={classes["sec-card1"]}>
              <b>Solution : </b>
              <span
                dangerouslySetInnerHTML={{ __html: quesData.sol_text }}
              ></span>
            </Card>

            {/*  */}
          </Card>
        )}
      </BorderedSec>
    </>
  );
};

export default Questions;
